import styled from "styled-components";

const Row = styled.div`
  display: flex;
  flex-direction: row;
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
`
export const MainContainer = styled.div`
  text-align: left;
  margin: 20px;
  gap: 15px;
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const Heading = styled.div`
  font-family: sans-serif !important;
  font-size: 32px;
  font-weight: 500;
  line-height: 1.19;
  text-align: left;
  margin-bottom: 20px;
  color: #3a3a3a;
`;
export const UploadButton = styled.a`
  text-decoration: none !important;
  font-size: 14px;
  color: white;
  border-radius: 8px;
  margin: 10px 0;
  border: none;
  background: #1caed0;
  padding: 10px 15px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const InputColumn = styled(Column)`
  width: 100%;
  gap: 15px;
  font-size: 18px !important;
  text-align: start;

  span {
    margin-top: 5px;
    margin-bottom: 5px;
  }
`;
export const InputRow = styled(Row)`
  padding: 30px 20px;
  border: solid 1px #dfe1e6;
  border-radius: 6px;
  margin-right: 35px;
  background-color: #fafbfc;
  gap: 30px;
`;
